import type { PreviewInsets } from '../../../../src/types/route-preview.ts';

export const PREVIEW_BADGE_SIZE = 32;
const BADGE_SCALE = PREVIEW_BADGE_SIZE / 24;
export const DESTINATION_PIN_WIDTH = 32.491 * BADGE_SCALE;
export const DESTINATION_PIN_HEIGHT = 42 * BADGE_SCALE;
export const DESTINATION_PIN_TIP_Y = 39.2966 * BADGE_SCALE;
export const DESTINATION_BADGE_TOP = 4 * BADGE_SCALE;
export const CALLOUT_GAP = 8;
export const VIEWPORT_GAP = 8;
const MAX_CALLOUT_WIDTH = 260;

/** Design-review range: compact at airport overview zoom, full size at route zoom. */
export const getPreviewBadgeSize = (zoom: number) => Math.round(24 + Math.max(0, Math.min(1, (zoom - 14) / 2)) * 8);

/** Place the label in usable map space while leaving the badge's geographic anchor untouched. */
export function getCalloutPlacement(
  point: { x: number; y: number },
  viewport: { width: number; height: number },
  insets: PreviewInsets = {},
  calloutHeight = 48,
  calloutWidth?: number,
  badgeWidth = PREVIEW_BADGE_SIZE,
) {
  const left = (insets.left ?? 0) + VIEWPORT_GAP;
  const right = viewport.width - (insets.right ?? 0) - VIEWPORT_GAP;
  const top = (insets.top ?? 0) + VIEWPORT_GAP;
  const bottom = viewport.height - (insets.bottom ?? 0) - VIEWPORT_GAP;
  const offset = badgeWidth / 2 + CALLOUT_GAP;
  const rightSpace = right - point.x - offset;
  const leftSpace = point.x - left - offset;
  const side = rightSpace >= leftSpace ? 'right' : 'left';
  const maxWidth = Math.max(0, Math.min(MAX_CALLOUT_WIDTH, Math.max(rightSpace, leftSpace)));
  const width = Math.min(calloutWidth ?? maxWidth, maxWidth);
  const labelTop = point.y - calloutHeight / 2;
  const visible = width > 0 && labelTop >= top && labelTop + calloutHeight <= bottom;
  return {
    side,
    visible,
    maxWidth,
    width,
    y: -calloutHeight / 2,
  } as const;
}
